/** Static legal PDF served by the backend; opened in a new tab from the consent banner. */
export const COOKIE_POLICY_HREF = '/legal/cookie-policy.pdf'
